<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked()">
        <tab title="Not Submitted">
            <ag-grid-angular class="data-grid " [rowData]="notSubmittedDataCorrectionRequests" [gridOptions]="notSubmittedGridOptions"  [attr.aria-label]="widgetTitle + ' - Not Submitted'">
            </ag-grid-angular>
        </tab>
        <tab title="Pending">
            <ag-grid-angular class="data-grid " [rowData]="pendingReviewDataCorrectionRequests" [gridOptions]="pendingReviewGridOptions"  [attr.aria-label]="widgetTitle + ' - Pending'">
            </ag-grid-angular>
        </tab>
        <tab title="Returned">
            <ag-grid-angular class="data-grid " [rowData]="returnedDataCorrectionRequests" [gridOptions]="returnedGridOptions"  [attr.aria-label]="widgetTitle + ' - Returned'">
            </ag-grid-angular>
        </tab>
        <tab title="Approved">
            <ag-grid-angular class="data-grid " [rowData]="approvedDataCorrectionRequests" [gridOptions]="approvedGridOptions"  [attr.aria-label]="widgetTitle + ' - Approved'">
            </ag-grid-angular>
        </tab>
        <tab title="Denied">
            <ag-grid-angular class="data-grid " [rowData]="deniedDataCorrectionRequests" [gridOptions]="deniedGridOptions"  [attr.aria-label]="widgetTitle + ' - Denied'">
            </ag-grid-angular>
        </tab>
    </tabs>
</div>